import React, { useEffect, useState } from "react";
import { useTableContext } from "../../context/TableContext";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";

const SelectTableId = ({ label, name, value, onChange, currentTableId, fiedlType }) => {
  const [allTables, setAllTables] = useState([]);
  const { tableData } = useTableContext();

  const fetchTables = () => {
    const obj = {};
    tableData.forEach((ele) => {
      obj[ele.table.id] = ele.table;
    });
    setAllTables(obj);
  };

  useEffect(() => {
    fetchTables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTableOptions = (allTables, currentTableId, fiedlType) => {
    return Object.values(allTables).filter((table) => {
      if (
        (fiedlType === "lookup" ||
          fiedlType === "recordset-list" ||
          fiedlType === "grid" ||
          fiedlType === "rich-grid") &&
        table.table_type === "entity"
      ) {
        return currentTableId !== table.id;
      } else if (fiedlType === "lookup-sm" || fiedlType === "linked-sm-lookup") {
        return true;
        // return currentTableId !== table.id; // If you want to remove current sm from list than uncomment this line
      } else {
        return false;
      }
    });
  };

  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={value}
        options={getTableOptions(allTables, currentTableId, fiedlType) || []}
        onChange={(obj) => onChange(name, obj.id)}
        placeholder="Select Table"
        labelKey={["table_name"]}
        label={label}
      />
    </div>
  );
};

export default SelectTableId;
